"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=radiology-procedure.dto.js.map